import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "pcfooter-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.status")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.status,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "status", $$v);
      },
      expression: "value.status"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.content")
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("com.dragSort"),
      "show-icon": ""
    }
  })], 1), _c("a-row", [_c("a-row", {
    staticStyle: {
      border: "1px solid #eee",
      "border-bottom": "0",
      "margin-bottom": "24px"
    }
  }, [_c("draggable", {
    staticClass: "dragArea",
    attrs: {
      tag: "div",
      list: _vm.value.custominfo
    }
  }, _vm._l(_vm.value.custominfo, function (item, i) {
    return _c("div", {
      key: i,
      staticClass: "list-item",
      on: {
        click: function click($event) {
          return _vm.handleListItemClick(item, i);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item.type === 0 ? _vm.$t("form.logoInfo") : item.title[_vm.defaultLangId]))]), _c("a-popconfirm", {
      attrs: {
        title: _vm.$t("com.askDelete"),
        "ok-text": _vm.$t("com.ok"),
        "cancel-text": _vm.$t("com.cancel"),
        placement: "topRight",
        overlayStyle: {
          minWidth: "200px"
        }
      },
      on: {
        confirm: function confirm($event) {
          return _vm.handleMenuDelete(i);
        }
      }
    }, [_c("a-icon", {
      attrs: {
        type: "delete"
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
        }
      }
    })], 1)], 1);
  }), 0)], 1), _c("a-row", [_c("a-dropdown", [_c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    on: {
      click: _vm.handleMenuClick
    },
    slot: "overlay"
  }, [_c("a-menu-item", {
    key: "0"
  }, [_vm._v(" " + _vm._s(_vm.$t("form.siteLogo")))]), _c("a-menu-item", {
    key: "1"
  }, [_vm._v(" " + _vm._s(_vm.$t("form.customLink")))])], 1), _c("a-button", {
    class: {
      disabled: _vm.value.custominfo.length >= 5
    },
    staticStyle: {
      width: "100%",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t("form.placeSelectContent")) + " "), _c("a-icon", {
    attrs: {
      type: "down"
    }
  })], 1)], 1)], 1)], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.copyrightContent")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.dividingLineColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.coyprightLineColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "coyprightLineColor", $$v);
      },
      expression: "value.coyprightLineColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.copyright"),
      layout: "vertical"
    }
  }, [_c("a-input", {
    model: {
      value: _vm.value.coypright,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "coypright", $$v);
      },
      expression: "value.coypright"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.coyprightTextColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "coyprightTextColor", $$v);
      },
      expression: "value.coyprightTextColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.coyprightFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "coyprightFontSize", $$v);
      },
      expression: "value.coyprightFontSize"
    }
  })], 1)], 1)], 1), _c("FormEditPage", {
    attrs: {
      show: _vm.showEditLogo,
      title: "LOGO"
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showEditLogo = $event;
      }
    }
  }, [_vm.value.custominfo[_vm.curInfoItem] ? _c("a-row", [_c("Card", {
    attrs: {
      title: _vm.$t("form.info")
    }
  }, [_c("CardItem", {
    attrs: {
      title: "LOGO",
      layout: "vertical"
    }
  }, [_c("FileUpload", {
    attrs: {
      list: _vm.logoList
    },
    on: {
      delete: _vm.handleLogoDelete,
      success: function success(val) {
        return _vm.handleLogoUploadSuccess(val, _vm.value.custominfo[_vm.curInfoItem]);
      }
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.logoWidth"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 20,
      max: 240,
      suffix: "px"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].logoWidth,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "logoWidth", $$v);
      },
      expression: "value.custominfo[curInfoItem].logoWidth"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.text")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        _vm.showEditText = true;
      }
    }
  })], 1), _c("CardItem", [_vm.value.custominfo[_vm.curInfoItem].subContent ? _c("a-textarea", {
    attrs: {
      disabled: "",
      readOnly: "",
      rows: "5"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].subContent[_vm.defaultLangId],
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem].subContent, _vm.defaultLangId, $$v);
      },
      expression: "value.custominfo[curInfoItem].subContent[defaultLangId]"
    }
  }) : _vm._e()], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].textFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "textFontSize", $$v);
      },
      expression: "value.custominfo[curInfoItem].textFontSize"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].textFontColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "textFontColor", $$v);
      },
      expression: "value.custominfo[curInfoItem].textFontColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconHoverColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].textActFontColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "textActFontColor", $$v);
      },
      expression: "value.custominfo[curInfoItem].textActFontColor"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.shareMedia")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.shareMedia")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        _vm.showEditIcon = true;
      }
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.mediaIconRight"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].shareIconMarignRight,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "shareIconMarignRight", $$v);
      },
      expression: "value.custominfo[curInfoItem].shareIconMarignRight"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.mediaIconBottom"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].shareIconMarignBottom,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "shareIconMarignBottom", $$v);
      },
      expression: "value.custominfo[curInfoItem].shareIconMarignBottom "
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c("FormEditPage", {
    attrs: {
      title: _vm.$t("form.text"),
      show: _vm.showEditText
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showEditText = $event;
      }
    }
  }, [_vm.value.custominfo[_vm.curInfoItem] ? _c("a-row", [_c("Title", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].subContent,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "subContent", $$v);
      },
      expression: "value.custominfo[curInfoItem].subContent"
    }
  })], 1) : _vm._e()], 1), _c("FormEditPage", {
    attrs: {
      title: _vm.$t("form.shareMedia"),
      show: _vm.showEditIcon
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showEditIcon = $event;
      }
    }
  }, [_vm.value.custominfo[_vm.curInfoItem] && _vm.value.custominfo[_vm.curInfoItem].shareIcon ? _c("a-row", {
    staticClass: "shareIconCollapse"
  }, [_c("a-collapse", {
    attrs: {
      bordered: false,
      expandIconPosition: "right"
    },
    model: {
      value: _vm.activeKey,
      callback: function callback($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, [_vm._l(_vm.value.custominfo[_vm.curInfoItem].shareIcon, function (item, i) {
    return [_c("a-collapse-panel", {
      key: i + "",
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_c("CardItem", {
            staticClass: "shareicon",
            attrs: {
              title: item.name
            }
          }, [_c("a-switch", {
            attrs: {
              "checked-children": _vm.$t("form.visible"),
              "un-checked-children": _vm.$t("form.hidden")
            },
            nativeOn: {
              click: function click($event) {
                $event.stopPropagation();
              }
            },
            model: {
              value: item.status,
              callback: function callback($$v) {
                _vm.$set(item, "status", $$v);
              },
              expression: "item.status"
            }
          })], 1)];
        },
        proxy: true
      }], null, true)
    }, [_c("a-row", [_c("a-row", [_c("div", [_vm._v(_vm._s(_vm.$t("form.icon")) + "：")]), _c("FileUpload", {
      attrs: {
        list: _vm.iconList(i)
      },
      on: {
        success: function success(val) {
          return _vm.handleUploadSuccess(val, item, i);
        }
      }
    })], 1), _c("a-row", [_c("div", [_vm._v(_vm._s(_vm.$t("form.iconSize")) + "：")]), _c("InputBar", {
      attrs: {
        min: 24,
        max: 64,
        suffix: "px"
      },
      model: {
        value: item.icon_size,
        callback: function callback($$v) {
          _vm.$set(item, "icon_size", $$v);
        },
        expression: "item.icon_size"
      }
    })], 1), _c("a-row", {
      style: {
        marginTop: "16px",
        marginBottom: item.type == 1 ? "16px" : 0
      },
      attrs: {
        type: "flex",
        justify: "space-between",
        align: "middle"
      }
    }, [_c("span", [_vm._v(_vm._s(_vm.$t("form.mediaIconType")) + "：")]), _c("a-radio-group", {
      staticClass: "mediaIconTypeBox",
      attrs: {
        "button-style": "solid"
      },
      model: {
        value: item.type,
        callback: function callback($$v) {
          _vm.$set(item, "type", $$v);
        },
        expression: "item.type"
      }
    }, [_c("a-radio-button", {
      attrs: {
        value: 0
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("form.link")) + " ")]), _c("a-radio-button", {
      attrs: {
        value: 1
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("form.image")) + " ")])], 1)], 1), item.type === 0 ? _c("CardItem", {
      attrs: {
        layout: "vertical"
      }
    }, [_c("div", {
      staticStyle: {
        color: "#1E1E1E"
      }
    }, [_vm._v(_vm._s(_vm.$t("form.link")) + "：")]), _c("a-textarea", {
      attrs: {
        rows: "5",
        placehoder: _vm.$t("com.link")
      },
      model: {
        value: item.content,
        callback: function callback($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    })], 1) : _vm._e(), item.type === 1 ? _c("a-row", [_c("FileUpload", {
      attrs: {
        list: _vm.wxmpList(i)
      },
      on: {
        success: function success(val) {
          return _vm.handleIconUploadSuccess(val, item, i);
        }
      }
    })], 1) : _vm._e()], 1)], 1)];
  })], 2)], 1) : _vm._e()], 1), _c("FormEditPage", {
    attrs: {
      title: _vm.$t("form.content"),
      show: _vm.showEditLink
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showEditLink = $event;
      }
    }
  }, [_vm.value.custominfo[_vm.curInfoItem] ? _c("a-row", [_c("Card", {
    attrs: {
      title: _vm.$t("form.mainTitle")
    }
  }, [_c("Title", {
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].title,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "title", $$v);
      },
      expression: "value.custominfo[curInfoItem].title"
    }
  }), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].titleColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "titleColor", $$v);
      },
      expression: "value.custominfo[curInfoItem].titleColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.dividingColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].titleSubColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "titleSubColor", $$v);
      },
      expression: "value.custominfo[curInfoItem].titleSubColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].titleFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "titleFontSize", $$v);
      },
      expression: "value.custominfo[curInfoItem].titleFontSize"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.customLink")
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("com.dragSort"),
      "show-icon": ""
    }
  })], 1), _vm.value.custominfo[_vm.curInfoItem] ? _c("a-row", [_c("a-row", {
    staticStyle: {
      border: "1px solid #eee",
      "border-bottom": "0",
      "margin-bottom": "24px"
    }
  }, [_c("draggable", {
    attrs: {
      tag: "div",
      list: _vm.value.custominfo[_vm.curInfoItem].content
    }
  }, _vm._l(_vm.value.custominfo[_vm.curInfoItem].content, function (item, i) {
    return _c("div", {
      staticClass: "list-item",
      on: {
        click: function click($event) {
          return _vm.handleListLinkClick(item, i);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item.title[_vm.defaultLangId]))]), _c("a-popconfirm", {
      attrs: {
        title: _vm.$t("com.askDelete"),
        "ok-text": _vm.$t("com.ok"),
        "cancel-text": _vm.$t("com.cancel"),
        placement: "topRight",
        overlayStyle: {
          minWidth: "200px"
        }
      },
      on: {
        confirm: function confirm($event) {
          return _vm.handleDeleteLinkByIndex(i);
        }
      }
    }, [_c("a-icon", {
      attrs: {
        type: "delete"
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
        }
      }
    })], 1)], 1);
  }), 0)], 1), _c("a-row", [_c("a-button", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "24px"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleAddLinkClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("form.addCustomLink")) + " ")])], 1)], 1) : _vm._e(), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].textFontColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "textFontColor", $$v);
      },
      expression: "value.custominfo[curInfoItem].textFontColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconHoverColor2")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].hoverTextFontColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "hoverTextFontColor", $$v);
      },
      expression: "value.custominfo[curInfoItem].hoverTextFontColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].textFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem], "textFontSize", $$v);
      },
      expression: "value.custominfo[curInfoItem].textFontSize"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c("FormEditPage", {
    attrs: {
      title: _vm.$t("form.customLink"),
      show: _vm.showEditLink_link
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showEditLink_link = $event;
      }
    }
  }, [_vm.value.custominfo[_vm.curInfoItem].content && _vm.value.custominfo[_vm.curInfoItem].content[_vm.curLinkItem] ? _c("a-row", [_c("Title", {
    attrs: {
      type: "input",
      default: _vm.$t("form.customLink")
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].content[_vm.curLinkItem].title,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem].content[_vm.curLinkItem], "title", $$v);
      },
      expression: "value.custominfo[curInfoItem].content[curLinkItem].title"
    }
  }), _c("CardItem", {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      title: _vm.$t("com.link")
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: "5"
    },
    model: {
      value: _vm.value.custominfo[_vm.curInfoItem].content[_vm.curLinkItem].link,
      callback: function callback($$v) {
        _vm.$set(_vm.value.custominfo[_vm.curInfoItem].content[_vm.curLinkItem], "link", $$v);
      },
      expression: "value.custominfo[curInfoItem].content[curLinkItem].link"
    }
  })], 1), _c("a-row", [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleDeleteLink
    }
  }, [_vm._v(_vm._s(_vm.$t("form.deleteContent")) + " ")])], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };